export default __webpack_public_path__ + "static/media/phone.7a7ed9b6.webp";